module.exports = __webpack_public_path__ + "img/card-rp-bills-received-report.26f048a6.svg";